let options: any;
if (window.location.host === "customer.autoversemobility.in") {
    options = {
        BASE_API_URL: "https://iapi.getpitstop.com/v1.0/pitstopspare",   
        BASE_API_URL_ELASTIC: "https://elastic.getpitstop.com/elasticsearch/api/v1",        
        // BASE_API_URL_SPARES: "https://iapi.getpitstop.com/v1.0/pitstopspare",    
        LANGUAGE: "en",
        DEVICE: "web",
        GOOGLE_MAPS_API_KEY: "AIzaSyA-FwkEuPz6efVsc-NszVSD-Fgo4-gXcvA",
        userId: "e0be18e8ed0e43e6dfc47036c3763acd"
    };
} else if (window.location.host.indexOf("test.customer.autoversemobility.in") > -1) {
    options = {
        BASE_API_URL: "https://iapi.testpitstop.com/v1.0/pitstopspare",  
        BASE_API_URL_ELASTIC: "https://elastic.testpitstop.com/elasticsearch/api/v1",            
        LANGUAGE: "en",
        DEVICE: "web",
        GOOGLE_MAPS_API_KEY: "AIzaSyA-FwkEuPz6efVsc-NszVSD-Fgo4-gXcvA",
        userId: "6fa9382d158400a191fde560b212859b"
    };
} else {
    options = {
        BASE_API_URL: "https://iapi.testpitstop.com/v1.0/pitstopspare",  
        BASE_API_URL_ELASTIC: "https://elastic.testpitstop.com/elasticsearch/api/v1",             
        LANGUAGE: "en",
        DEVICE: "web",
        GOOGLE_MAPS_API_KEY: "AIzaSyA-FwkEuPz6efVsc-NszVSD-Fgo4-gXcvA",
        userId: "6fa9382d158400a191fde560b212859b"
    };
}
export const GlobalVariable = Object.freeze(options);







































